import api from '../../api/index.api'
import DictTypes from './dict.types'

export const onGetListDictWord = (data, cb) => {
	return async dispatch => {
		try {
			const result = await api.dictWordApi.getListDictWords(data)
			result.currentPage = data.pageNum + 1
			dispatch({
				type: DictTypes.GET_LIST_DICT_WORD,
				payload: result,
			})
			cb && cb(true, result)
		} catch (err) {
			cb && cb(false, err.message)
		}
	}
}

export const onSelectDictWord = (data, cb) => {
	return async dispatch => {
		try {
			dispatch({
				type: DictTypes.SELECT_DICT_WORD,
				payload: data,
			})
			cb && cb(true, data)
		} catch (err) {
			cb && cb(false, err.message)
		}
	}
}

export const onCreateDictWord = (data, fCallBack) => {
	return async dispatch => {
		try {
			const rs = await api.dictWordApi.create(data)

			dispatch({
				type: DictTypes.CREATE_DICT_WORD,
				payload: rs,
			})
			fCallBack && fCallBack(true, rs)
		} catch (err) {
			if (fCallBack) {
				fCallBack(false, err.message)
			}
		}
	}
}

export const onDeleteDictWord = (data, fCallBack) => {
	return async dispatch => {
		try {
			await api.dictWordApi.remove(data)

			dispatch({
				type: DictTypes.DELETE_DICT_WORD,
				payload: data,
			})
			fCallBack && fCallBack(true, data)
		} catch (err) {
			if (fCallBack) {
				fCallBack(false, err.message)
			}
		}
	}
}
//dict types
export const onGetAllDictWordTypes = (data, cb) => {
	return async dispatch => {
		try {
			const result = await api.dictWordTypeApi.getAllWordTypes(data)
			result.currentPage = (data.pageNum || 0) + 1
			dispatch({
				type: DictTypes.GET_ALL_DICT_WORD_TYPE,
				payload: result,
			})
			cb && cb(true, result)
		} catch (err) {
			cb && cb(false, err.message)
		}
	}
}
export const onCreateDictWordTypes = (data, cb) => {
	return async dispatch => {
		try {
			const result = await api.dictWordTypeApi.create(data)
			dispatch({
				type: DictTypes.CREATE_DICT_WORD_TYPE,
				payload: result,
			})
			cb && cb(true, result)
		} catch (err) {
			cb && cb(false, err.message)
		}
	}
}
export const onUpdateDictWordTypes = (data, cb) => {
	return async dispatch => {
		try {
			await api.dictWordTypeApi.update(data)
			dispatch({
				type: DictTypes.UPDATE_DICT_WORD_TYPE,
				payload: data,
			})
			cb && cb(true, data)
		} catch (err) {
			cb && cb(false, err.message)
		}
	}
}
export const onDeleteDictWordTypes = (data, cb) => {
	return async dispatch => {
		try {
			const result = await api.dictWordTypeApi.remove(data)
			dispatch({
				type: DictTypes.DELETE_DICT_WORD_TYPE,
				payload: data,
			})
			cb && cb(true, result)
		} catch (err) {
			cb && cb(false, err.message)
		}
	}
}
export const onSelectWordType = (data, cb) => {
	return async dispatch => {
		try {
			dispatch({
				type: DictTypes.SELECT_DICT_WORD_TYPE,
				payload: data,
			})
			cb && cb(true, data)
		} catch (err) {
			cb && cb(false, err.message)
		}
	}
}
